export const secretCodeFields = [
  { title: 'old_code', value: '' },
  { title: 'new_code_first', value: '' },
  { title: 'new_code_second', value: '' },
]
export const mezzoDefaultPassword = '12345678'
